import Admin from "../pages/Admin";
import NewWebVersion from "../pages/NewWebVersion";
import WebVersion from "../pages/WebVersion";


interface RouteProps {
    path: string;
    component: any;
    exact?: boolean;
}

export const allRoutesWeb: Array<RouteProps> = [
    { path: "/", component: NewWebVersion },
    { path: "/admin", component: Admin },
];